import Modal from "@mui/material/Modal";
import SystemDialogClosingCrossIcon from "../icons/SystemDialogClosingCrossIcon";
import SystemDialogHeaderLayout from "../layouts/SystemDialogHeaderLayout";
import {kButtonStyles, kModalStyles} from "../../constants/styles";
import SystemModalTexts from "../texts/SystemModalTexts";
import {SystemSecondaryCustomButton} from "../buttons/SystemCustomButton";
import {renderScoreIceEmoji} from "../../controllers/flashScreens/resultsStepScreen/ResultsScoreEmojiImageController";
import {
    computeResultsFlashAppreciation
} from "../../controllers/flashScreens/resultsStepScreen/ResultsFlashAppreciationController";
import {kSystemTexts} from "../../constants/texts";
import SystemDialogMainImage from "../images/SystemDialogMainImage";

export default function SystemResultsAppreciationDialog({open, handleClose, successRatio}) {
    // Used in FlashResultsScore to show total score related appreciation
    // in a modal

    // BUILD
    return(
        <Modal open={open}
               onClose={handleClose}>
            <div className={kModalStyles.dialogStyle}>
                <SystemDialogHeaderLayout>
                    <SystemDialogClosingCrossIcon onIconPress={() => handleClose()} />
                    <SystemDialogMainImage imageUrl={renderScoreIceEmoji(successRatio)} />
                </SystemDialogHeaderLayout>
                <SystemModalTexts title={computeResultsFlashAppreciation(successRatio)} />
                <SystemSecondaryCustomButton
                    label={kSystemTexts.back}
                    isDisabled={false}
                    isLoading={false}
                    isFullWidth={true}
                    onButtonClick={() => handleClose()}
                    sizeStyle={kButtonStyles.mediumButtonStyle} />
            </div>
        </Modal>
    )
}